import Verifications from "./Verifications";

export default Verifications;
